import React from "react";
import {
    Box,
    Card,
    Heading,
    Icon,
    Image,
    SimpleGrid,
} from "@chakra-ui/react";
import {useColorModeValue} from "../ui/color-mode";
import {FiCamera} from "react-icons/fi";

const DemoFarmPhotosCard = () => {
    const cardBg = useColorModeValue("white", "");

    // Static demo photos from /public
    const demoPhotos = [
        {src: "farmPhotos/orange1.jpg", alt: "Orange orchard view 1"},
        {src: "farmPhotos/orange2.jpg", alt: "Orange orchard view 2"},
        {src: "farmPhotos/orange3.jpg", alt: "Orange orchard view 3"},
        {src: "farmPhotos/orange4.jpg", alt: "Orange orchard view 4"},
    ];

    return (
        <Box as="section" w="100%">
            <Card.Root bg={cardBg} borderRadius="xl" p={4}>
                <Heading size="md" mb={4}>
                    <Icon as={FiCamera} mr={2} color="purple.500"/>
                    Photos of Production Unit
                </Heading>

                <SimpleGrid columns={[1, 2, 3]} columnGap="2" rowGap="2">
                    {demoPhotos.map((photo, index) => (
                        <Box key={index} overflow="hidden" rounded="md">
                            <Image
                                src={photo.src}
                                alt={photo.alt}
                                objectFit="cover"
                                width="100%"
                                height="200px"
                            />
                        </Box>
                    ))}
                </SimpleGrid>
            </Card.Root>
        </Box>
    );
};

export default DemoFarmPhotosCard;